import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import { animation } from '@angular/animations';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {

  constructor(public authService: AuthService,
    public router: Router) { }
cve:number;
  ngOnInit() {
    this.cve=Number(localStorage.getItem("id_persona"));
    //console.log(this.cve);
    this.competencia();
    this.ls_cda(this.cve);
    this.ls_kdr(this.cve);
    this.ls_kpi(this.cve);
    this.ls_dke(this.cve);
    this.get_persona(this.cve);
    this.get_experience(this.cve);
    this.get_reportto(this.cve);

    console.log(localStorage.getItem("tprint"));
    switch (localStorage.getItem("tprint")) {
      case "4":
        this.version_(1);break;
      case "3":
        this.version_(2);break;    
      default:
        break;
    }

    
    this.get_education(this.cve)
    this.get_we(this.cve);
    this.pfp_ps(this.cve);
    this.view_nineb_current();
    this.view_nineb_last();
  }
  _competencia;
  competencia(){
    let postData_c = { 
      id_cliente:localStorage.getItem("id_cliente"),
      id_usuario:this.cve
    } 
    console.log(postData_c)
     this.authService.service("/api/get_competencias_cliente_per",postData_c)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this._competencia=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta! gdareportto', '', 'error');
        });   
  }
  we;  
  get_we(cve){
    let postData = {
      id_persona:cve
    }
    this.authService.service("/api/get_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);       
          //console.log('-------------  ');       
          //console.log(dat);       
          if (res.length!=0)
          {
            this.we=data;          
          }          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  pfpps
  pfp_ps(cve){   
    let postData = {
      id_persona:cve,
    } 
    //console.log(postData);
    this.authService.service("/api/get_pfpps",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);  
          //console.log("pfpps");            
          //console.log(res);            
          this.pfpps=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  get_education(cve){
    let postData = {
      id_persona:cve,
    } 
    //console.log(postData);
    this.authService.service("/api/get_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.edu=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  edu;
  persona={
    ingreso:"",
    nombre:"",
    apaterno:"",
    amaterno:"",
    profesion:"",
    foto:""
  };
  ver;
  version_(v){
    this.ver=v;
  }
  nineb_last=0;
  nineb=0;
  view_nineb_last(){
    let postData = {
      id_persona:this.cve,
      id_evaluador:0,
      a:"L"
    };
    this.authService.service("/api/nine_box_last",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                        
          this.nineb_last=res[0].nineb;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
  
  }
  view_nineb_current(){
    let postData = {
      id_persona:this.cve,
      id_evaluador:0,
      a:"C"
    };
    console.log(postData)
    this.authService.service("/api/nine_box",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          console.log(res);
          this.nineb=res[0].nineb;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
  
  }
  public loading;

  get_persona(cve){
    let postData = {
      id_persona:cve } 
      //console.log(postData);
      this.authService.service("/api/get_persona_id",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            //console.log(data[0]);
            this.persona.nombre=data[0].nombre;
            this.persona.apaterno=data[0].apaterno;
            this.persona.amaterno=data[0].amaterno;
            this.persona.profesion=data[0].profesion;
            this.persona.ingreso=data[0].ingreso.toString().substring(0,10);
            this.persona.foto=data[0].foto;
            if(this.persona.foto=="" || this.persona.foto==null){
              this.persona.foto="https://hoshinup.garocedev.com:3007/image-none.jpg";
            }else{
              this.persona.foto="https://hoshinup.garocedev.com:3007/"+data[0].foto;
              
              
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! reportto', '', 'error');
          });     
  }
  reportto:any;
  get_reportto(cve){
    this.reportto=[];
    let postData = {
      id_persona:cve } 
      
      this.authService.service("/api/get_reportto",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                      
            //console.log(res);      
            this.reportto=data;
        
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! reportto', '', 'error');
          });       
  }
  cda:any;
  kdr:any;
  kpi:any;
  dke:any;
  exp={
    id:0,
    posicion:"",
    txdirRep1:"",
    txdirRep2:"",
    descripcion:""
    
  }
  _mAre1;
  _mAre2;
  get_experience(id_){
    let postData = {
      id:id_ 
    } 
      //console.log(postData);
      this.authService.service("/api/get_experience",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
              //console.log(res[0]);              
              this.exp.id=res[0].id;
              this.exp.posicion=res[0].titulo;
              this.exp.descripcion=res[0].descripcion;
              this._mAre1=res[0].idarea1;
              this._mAre2=res[0].idarea2;
              this.exp.txdirRep1=res[0].txdirRep1;
              this.exp.txdirRep2=res[0].txdirRep2;
                      
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  ls_cda(id_){
    let postData = {id:id_} 
    this.authService.service("/api/get_cda",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.cda=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_kdr(id_){
    let postData = {id:id_  }     
    this.authService.service("/api/get_kdr",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kdr=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  ls_kpi(id_){
    let postData = {id:id_ } 
    this.authService.service("/api/get_kpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kpi=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  ls_dke(id_){
    let postData = { id:id_ } 
    this.authService.service("/api/get_dke",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.dke=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
}
